const areDifferent = (ob1 = {}, ob2 = {}) => {
    const keys1 = Object.keys(ob1)
    return keys1.length !== Object.keys(ob2).length
        || keys1.some(key => ob1[key] !== ob2[key])
}

export default areDifferent